import { baseApiService } from "../../../shared/services/api/axios-config/axios-config";
import { errosHandler } from "../../../shared/services/errors/erros-handler";
import { CancelarMovimentacaoFinanceiraFormData } from "../schema/cancelar-movimentacao-financeira.schema.ts";
import { MovimentacaoObraFormData } from "../schema/gerar-movimentacao-obra.schema";

const totaisMovimentacoesObras = async (query: string): Promise<any> => {
    try {
        const response = await baseApiService.get(`/financi-moviment/totals-to-work?${query}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const listaMovimentacoesObras = async (query: string, pagina = 0, limite = 10): Promise<any> => {
    try {
        const response = await baseApiService.get(`/financi-moviment/list-to-work?page=${pagina + 1}&limit=${limite}&${query}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const gerarMovimentacoesObras = async (data: MovimentacaoObraFormData[]): Promise<void> => {
    try {
        await baseApiService.post('/financi-moviment/generate', data);
    } catch (err) {
        throw errosHandler(err);
    }
};

const cancelar = async (id: string, data: CancelarMovimentacaoFinanceiraFormData): Promise<void> => {
    try {
        await baseApiService.put(`/financi-moviment/cancel/${id}`, data);
    } catch (err) {
        throw errosHandler(err);
    }
};



const detalhar = async (id: string): Promise<any> => {
    try {
        const response = await baseApiService.get(`/financi-moviment/${id}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

export const financeiroService = {
    totaisMovimentacoesObras,
    listaMovimentacoesObras,
    gerarMovimentacoesObras,
    detalhar,
    cancelar
};
